// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, onAuthStateChanged, sendSignInLinkToEmail, isSignInWithEmailLink, signInWithEmailLink } from 'firebase/auth';
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyDxZdLjGeR8qPIj0JS1PPJ4k6Ilip9mAe8",
    authDomain: "interbot-2e575.firebaseapp.com",
    projectId: "interbot-2e575",
    storageBucket: "interbot-2e575.appspot.com", // Corregido para apuntar al bucket correcto
    messagingSenderId: "316196263046",
    appId: "1:316196263046:web:1cb42e13476ee21d5ced07"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export {
  auth,
  db,
  storage,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink
};